import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import MakeDuePaymentModal from "./Payment/MakeDuePaymentModal";
import CartPreview from "./Cart/CartPreview";
import { handleLogout_store } from "../redux/store";

const Header = () => {
  const loggedInStatus = useSelector(
    (state) => state.bookingValidation.loggedInStatus
  );
  const bookingValidation = useSelector(
    (state) => state.bookingValidation.data
  );
  const [showPaymentModal, setShowPaymentModal] = React.useState(false);
  const cartItems = useSelector((state) => state.cart.cartItems);
  const location = useLocation();
  const navigate = useNavigate();
  const [showCartPreview, setShowCartPreview] = React.useState(false);
  const [showMenu, setShowMenu] = React.useState(false);

  const handleLogout = () => {
    handleLogout_store();
    sessionStorage.clear();
    navigate("/");
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const paymentModal = urlParams.get("setShowPaymentModal");
    if (paymentModal) {
      setShowPaymentModal(true);
    }
  }, [location]);

  return (
    <>
      <div className="fixed h-screen z-50 md:mt-32">
        <MakeDuePaymentModal
          showPaymentModal={showPaymentModal}
          setShowPaymentModal={setShowPaymentModal}
        />
      </div>
      {loggedInStatus && (
        <div className="p-2 bg-[#FFDF5D] flex justify-center">
          <span className="font-semibold text-xl text-mv-darkblue ">
            SAVE 10% ON ALL PRE-BOOKED PACKAGES AND EXCURSIONS.{" "}
            <Link className="underline" to={`?currentTab=Enhance Sailing`}>
              Click here
            </Link>{" "}
            to add enhancements.{" "}
          </span>
        </div>
      )}
      <header className="flex items-center p-4 bg-mv-darkblue shadow-md md:flex-row flex-col">
        <div className="flex w-full items-center justify-between">
          <div onClick={() => navigate("./")} className="cursor-pointer">
            <img
              src={`${process.env.PUBLIC_URL}/assets/header/mv-logo.svg`}
              alt="logo"
            />
          </div>
          {loggedInStatus && (
            <div className="md:flex hidden items-center space-x-8 text-white">
              <div className="">
                <button
                  onMouseEnter={() => setShowCartPreview(true)}
                  onMouseLeave={() => setShowCartPreview(false)}
                  onClick={() => navigate("./cart")}
                  className="flex  gap-2 items-center"
                >
                  <div className="w-10 h-10 relative">
                    <img
                      src={`${process.env.PUBLIC_URL}/assets/header/cart-logo.png`}
                      alt=""
                    />
                    {cartItems.length !== 0 && (
                      <span className="absolute flex justify-center items-center top-0 right-0 w-5 h-5 bg-red-600 text-center font-bold rounded-full text-lg">
                        {cartItems.length}
                      </span>
                    )}
                  </div>
                  <span className="ml-2 font-semibold">VIEW CART</span>
                </button>
                <div className="relative">
                  <div className="fixed rounded-md shadow-2xl z-50 right-0 bg-white w-1/3 h-auto">
                    {/* <svg
                    className="flex justify-center items-center bg-mv-darkblue rounded-full w-10 h-10 cursor-pointer"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                      fill="white"
                    >
                      <path d="M7 10l5 5 5-5H7z" />
                    </svg> */}
                    {showCartPreview && location.pathname !== "/cart" && (
                      <CartPreview />
                    )}
                  </div>
                </div>
              </div>
              {+bookingValidation?.payment_details.due_amount > 0 && (
                <button
                  onClick={() => navigate("?setShowPaymentModal=true")}
                  className="flex gap-2 items-center"
                >
                  <div className="w-10 h-10">
                    <img
                      src={`${process.env.PUBLIC_URL}/assets/header/card-logo.png`}
                      alt=""
                    />
                  </div>
                  <span className="ml-2 font-semibold">MAKE A PAYMENT</span>
                </button>
              )}
              <button onClick={handleLogout} className="flex items-center">
                <span className="ml-2 font-semibold">LOG OUT</span>
              </button>
            </div>
          )}
          <div className="md:hidden relative flex items-center">
            <button
              onClick={() => navigate("./cart")}
              className="flex gap-2 items-center mr-4"
            >
              <div className="w-6 h-6 relative">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/header/cart-logo.png`}
                  alt=""
                />
                {cartItems.length !== 0 && (
                  <span className="absolute flex justify-center items-center top-0 right-0 w-4 h-4 bg-red-600 text-center font-bold rounded-full text-xs">
                    {cartItems.length}
                  </span>
                )}
              </div>
            </button>
            <button
              onClick={() => setShowMenu(!showMenu)}
              className="flex items-center"
            >
              <img
                src={`${process.env.PUBLIC_URL}/assets/header/menu-icon.svg`}
                alt="menu"
                className="w-6 h-6"
              />
            </button>
          </div>
        </div>
      </header>
      {loggedInStatus && showMenu && (
        <div className="relative">
          <div className="md:hidden absolute left-0 top-0 right-0 z-40 bg-[#4B6C8F] w-full flex flex-col justify-start items-center py-2 space-y-4 text-white">
            {+bookingValidation.payment_details.due_amount > 0 && (
              <button
                onClick={() => navigate("?setShowPaymentModal=true")}
                className="flex w-4/5 justify-start gap-2 items-center"
              >
                <div className="w-6 h-6">
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/header/card-logo.png`}
                    alt=""
                  />
                </div>
                <span className="ml-2 font-semibold">MAKE A PAYMENT</span>
              </button>
            )}
            <button
              onClick={() => {
                navigate("./?currentTab=View Reservations");
                setShowMenu(false);
              }}
              className="flex w-4/5  justify-start items-center"
            >
              <span className="ml-2 font-semibold">Managing Booking</span>
            </button>
            <button
              onClick={() => {
                navigate("./?currentTab=Enhance Sailing");
                setShowMenu(false);
              }}
              className="flex w-4/5  justify-start items-center"
            >
              <span className="ml-2 font-semibold">Enhance Sailing</span>
            </button>
            <button
              onClick={() => {
                navigate("./?currentTab=Upgrade Staterooms");
                setShowMenu(false);
              }}
              className="flex w-4/5  justify-start items-center"
            >
              <span className="ml-2 font-semibold">Upgrade Staterooms</span>
            </button>
            <button
              onClick={() => {
                navigate("./?currentTab=Prepare to Sail");
                setShowMenu(false);
              }}
              className="flex w-4/5  justify-start items-center"
            >
              <span className="ml-2 font-semibold">Prepare to Sail</span>
            </button>
            {/* <button className="flex w-4/5  justify-start items-center">
              <span className="ml-2 font-semibold">FAQs</span>
            </button> */}
            <button
              onClick={handleLogout}
              className="flex w-4/5  justify-start items-center"
            >
              <span className="ml-2 font-semibold">LOG OUT</span>
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
